import React from 'react';
import { Box } from '@mui/material';

import { ICandidateDetails } from '@types';
import {
  CandidateCardSection,
  ClosedBanner,
  getCandidateSections,
  getCandidateVideo,
} from '../CandidateDetailSections/CandidateDetailSections';
import { VideoIntro } from '../CandidateVideoIntro/CandidateVideoIntro';

interface ICandidateDetailsContent {
  data: ICandidateDetails;
  isViewOnly?: boolean;
}

export const CandidateDetailsContent: React.FC<ICandidateDetailsContent> = ({
  data,
  isViewOnly = false,
}) => {
  const video = getCandidateVideo(data);

  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <Box sx={{ '&:empty': { display: 'none' } }}>
        <ClosedBanner data={data} />
      </Box>

      {Boolean(video) && <VideoIntro fileName={video!.recordFileName!} />}

      {getCandidateSections(data, { isViewOnly, includeVideo: false }).map(
        (section) => (
          <CandidateCardSection key={section.title} title={section.title}>
            {section.content}
          </CandidateCardSection>
        ),
      )}
    </Box>
  );
};
